import { PlusOutlined, RedoOutlined } from '@ant-design/icons'
import React, { useState, useEffect, useContext } from 'react'
import styled from 'styled-components'
import iconEmpty from 'icons/createproject/supportneed.svg'
import SelectTable from './RolePermission/permission'
import AdminManageTable from './RolePermission/adminManage'
import Delete from 'common/Management/delete'
import {
  Button,
  Form,
  Row,
  Col,
  Input,
  Table,
  notification,
  Alert,
  Modal,
} from 'antd'
import {
  getRole,
  adminAddRole,
  getMappingRole,
  getMenuList,
  updateRolePermission,
} from 'api/Admin/rolePermission'
import { getCookie } from 'helper/cookie'
import { CounterContext } from 'redux/Golbalvalues'
import lang from 'lang/en'
const Container = styled.div``
const RoleperContianer = styled.div``
const Header = styled.div``
const Body = styled.div``
const EmptyContainer = styled.div``
const TextTitleBold = styled.h2`
  font-family: 'IBMPlexSansThaiBold';
`

const initalState = {
  data: [],
  isLoading: true,
  pagination: {
    pageSize: 10, //จำนวนข้อมูลในหน้านั้น
    total: 0, //ข้อมูลทั้งหมด
    current: 1,
    showQuickJumper: 1,
    // showSizeChanger: true,
    // showTotal: (total, range) => showToalPagination(total, range),
  },
}
let wordError = ''

const roleandpermission = () => {
  const [form] = Form.useForm()
  const [dataRolepermis, setDataRolepermis] = useState(initalState.data)
  const [dataAdmin, setDataAdmin] = useState(initalState.data)
  const [visible, setVisible] = useState(false)
  const [stateDrawer, setStateDrawer] = useState('')
  const [titleDrawer, setTitleDrawer] = useState('')
  const [visibleDelete, setVisibleDelete] = useState(false)
  const [dataRole, setDataRole] = useState(initalState.data)
  const [dataEdit, setDataEdit] = useState(initalState.data)
  const [menuAdmin, setMenuAdmin] = useState(initalState.data)
  const [permissionAdmin, setPermissionAdmin] = useState(initalState.data)
  const [permission, setPermission] = useState(initalState.data)
  const [record, setRecord] = useState()
  const [idRole, setIdRole] = useState()
  const [pagination, setPagination] = useState(initalState.pagination)
  // เช็คไอดีซ้ำ
  const [hiddenError, setHiddenError] = useState(true)
  const token = getCookie('access_token_admin')

  const language = getCookie('lang')
  const word = lang[language]

  //checkrole
  const { adminPermission } = useContext(CounterContext)
  //check permission
  const [disablePage, setDisablePage] = useState(false)

  const [permissionPage, setPermissionPage] = useState({
    create: false,
    read: false,
    update: false,
    delete: false,
  })

  const roleUser = getCookie('roleUser')
  useEffect(() => {
    if (roleUser == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        create: true,
        read: true,
        update: true,
        delete: true,
      }))
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 20) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
        }
      })
    }
  }, [adminPermission])

  const getResultRole = async () => {

    console.log('getResultRole')
    await getRole({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setDataRole([])
          return true
        }
        if (status === 200) {
          console.log('data', data)
          setDataRole(data.result)
          if (data.length <= 10) {
            setPagination(false)
          } else {
            setPagination(initalState.pagination)
          }
        } else {
          setDataRole([])
          return true
        }
      })
      .catch((error) => {
        setDataRole([])
        console.error(error)
      })
  }
  const getResultMenuList = async () => {
    await getMenuList({
      token: token,
    })
      .then(async (response) => {
        const { status, data, error } = response
        if (error) {
          setMenuAdmin([])
          return true
        }
        if (status === 200) {
          data.result.map((item) => {
            if (item.name === 'Admin') {
              item.child.map((child) => {
                Object.assign(child, {
                  permission: {
                    menu_id: child.id,
                    create: false,
                    update: false,
                    read: false,
                    delete: false,
                  },
                })
              })
              setMenuAdmin(item.child)
            }
          })
        } else {
          setMenuAdmin([])
          return true
        }
      })
      .catch((error) => {
        setMenuAdmin([])
        console.error(error)
      })
  }
  useEffect(() => {
    if (token) {
      getResultMenuList()
      getResultRole()
    }
  }, [token])

  const dataSource = dataRole.map((item) => ({
    id: item.id,
    role_code: item.code,
    role_name: item.name,
    description: item.description ? item.description : '',
    count_user: item.count_user.toString(),
    data: item,
  }))
  const columns = [
    {
      title: <h5>{word['Role']}</h5>,
      dataIndex: 'role_code',
      sorter: (a, b) => a.role_code.localeCompare(b.role_code),
      width: 140,
      ellipsis: true,
    },
    {
      title: <h5>{word['Role_name']}</h5>,
      dataIndex: 'role_name',
      width: 180,
      sorter: (a, b) => a.role_name.localeCompare(b.role_name),
      ellipsis: true,
    },
    {
      title: <h5>{word['Description']}</h5>,
      dataIndex: 'description',
      width: 180,
      sorter: (a, b) => a.description.localeCompare(b.description),
      ellipsis: true,
    },
    {
      title: <h5>{word['Number_of_users']}</h5>,
      dataIndex: 'count_user',
      width: 180,
      sorter: (a, b) => a.count_user.localeCompare(b.count_user),
      ellipsis: true,
    },
  ]
  const setFieldsNull = () => {
    form.setFieldsValue({
      role_code: null,
      role: null,
      des: null,
    })
  }
  function onChange(pagination2, filters, sorter, extra) {
    if (pagination !== false) {
      setPagination((prevState) => {
        return {
          ...prevState,
          pageSize: pagination2.pageSize,
          current: pagination2.current,
        }
      })
    }
  }
  /// ADD
  const eventAdd = () => {
    setHiddenError(true)
    setDataEdit(initalState.data)
    setFieldsNull()
    getResultMenuList()
    setTitleDrawer('Add Role')
    setVisible(true)
    setStateDrawer('add')
    setDisablePage(false)
  }
  ///EDIT
  const eventEdit = (record) => {
    if (record.id == 1) {
      setPermissionPage((prevState) => ({
        ...prevState,
        update: false,
        delete: false,
      }))
      setDisablePage(true)
    } else {
      adminPermission.map((item) => {
        if (item.menu_id == 20) {
          setPermissionPage((prevState) => ({
            ...prevState,
            create: item.create == 'Y' ? true : false,
            read: item.read == 'Y' ? true : false,
            update: item.update == 'Y' ? true : false,
            delete: item.delete == 'Y' ? true : false,
          }))
          item.update == 'Y' ? setDisablePage(false) : setDisablePage(true)
        }
      })
    }
    form.setFieldsValue({
      role_code: record.role_code,
      role: record.role_name,
      des: record.description ? record.description : '',
    })
    try {
      getMappingRole({
        id: record.id,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          res.data.result.permission?.map((item, index) => {
            changeValueToFont(item)
            return item
          })
          setDataEdit(res.data.result)
        }
      })
    } catch (error) {
      console.log(error)
    }
    setHiddenError(true)
    setRecord(record)
    setIdRole(record.id)
    setTitleDrawer('Edit Role Member')
    setVisible(true)
    setStateDrawer('edit')
  }
  const content = () => {
    if (dataRole.length > 0) {
      return (
        <RoleperContianer>
          <Header className="layout-button-add-normal-state">
            <div className="layout-btn-reset-add">
              <Button
                onClick={eventAdd}
                icon={<PlusOutlined className="Icon-color" />}
                className="BTN_Next"
                hidden={permissionPage.create ? false : true}
              >
                {word['Add_Role']}
              </Button>
              <Button
                type="primary"
                style={{ marginLeft: 8 }}
                className="btn_Secondary2"
                onClick={() => window.location.reload()}
              >
                <RedoOutlined className="Icon-color" />
                {word['Reset']}
              </Button>
            </div>
          </Header>
          <Body>
            <Table
              key="role"
              onRow={(record) => {
                return {
                  onClick: () => eventEdit(record),
                }
              }}
              columns={columns}
              dataSource={dataSource}
              onChange={onChange}
              pagination={pagination}
              showSorterTooltip={false}
            />
          </Body>
        </RoleperContianer>
      )
    } else {
      return (
        <EmptyContainer className="initialstate-container">
          <img src={iconEmpty} />
          <h2>{word['Please_add_role_and_permssion']}</h2>
          <Button
            hidden={permissionPage.create ? false : true}
            onClick={eventAdd}
            icon={<PlusOutlined className="Icon-color" />}
            className="btn_Secondary2"
          >
            {word['Add_Role']}
          </Button>
        </EmptyContainer>
      )
    }
  }
  const renderButton_Drawer = () => {
    if (stateDrawer === 'add') {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button className="BTN_Next" onClick={form.submit}>
            {word['Save']}
          </Button>
        </div>
      )
    } else {
      return (
        <div
          style={{
            textAlign: 'right',
          }}
        >
          <Button
            className="BTN_Delete_CPF_RED"
            onClick={() => setVisibleDelete(true)}
            style={{ marginRight: 8 }}
            hidden={permissionPage.delete ? false : true}
          >
            {word['Delete']}
          </Button>
          <Button
            hidden={permissionPage.update ? false : true}
            className="BTN_Next"
            type="primary"
            onClick={form.submit}
          >
            {word['Save']}
          </Button>
        </div>
      )
    }
  }
  const changeValueToFont = (item) => {
    if (item.create === 'Y') {
      item.create = true
    } else {
      item.create = false
    }
    if (item.read === 'Y') {
      item.read = true
    } else {
      item.read = false
    }
    if (item.update === 'Y') {
      item.update = true
    } else if (item.update === 'N') {
      item.update = false
    }
    if (item.delete === 'Y') {
      item.delete = true
    } else {
      item.delete = false
    }
  }
  const changeValueToAPi = (item) => {
    if (item.create === true) {
      item.create = 'Y'
    } else {
      item.create = 'N'
    }
    if (item.read === true) {
      item.read = 'Y'
    } else {
      item.read = 'N'
    }
    if (item.update === true) {
      item.update = 'Y'
    } else if (item.update === false) {
      item.update = 'N'
    }
    if (item.delete === true) {
      item.delete = 'Y'
    } else {
      item.delete = 'N'
    }
  }
  const openNotificationWithIcon = (type, des) => {
    notification[type]({
      description: des,
      duration: 2,
    })
  }
  const onFinish = (val) => {
    let errSelect = false
    let checkSelectPermission = false
    let errCheckbox = false
    dataRolepermis.map((data, index) => {
      // ถ้าไม่มีการเลือก permission เลย
      if (
        data.permission.create ||
        data.permission.read ||
        data.permission.update ||
        data.permission.delete
      ) {
        checkSelectPermission = true
      }
      // ถ้าเลือก checkbox แต่ไม่เลือก menu
      if (
        data.permission.menu_id === undefined &&
        (data.permission.create ||
          data.permission.read ||
          data.permission.update ||
          data.permission.delete)
      ) {
        errSelect = true
      }
      // ถ้าเลือก menu แต่ไม่เลือก checkbox
      if (data.id !== 4 && data.id !== 5 && data.id !== 6) {
        //id 4 : proskill  id 5 : history id 6 : data analytics
        if (
          data.permission.menu_id !== undefined &&
          !data.permission.create &&
          !data.permission.read &&
          !data.permission.update &&
          !data.permission.delete
        ) {
          errCheckbox = true
        }
      }
    })
    if (!errSelect && checkSelectPermission && !errCheckbox) {
      if (stateDrawer === 'add') {
        handleAddRole(val)
      } else {
        handleUpdateRole(val)
      }
    } else {
      openNotificationWithIcon('warning', 'Please select permission')
    }
  }

  const mappingPermissionPayload = () => {

    const permis = dataRolepermis.map((item) => {
      changeValueToAPi(item.permission)
      return item.permission
    }
    )
    const admin = dataAdmin.map((item) => {
      changeValueToAPi(item.permission)
      return item.permission
    })
    const dataPermission = [...permis, ...admin]
    return dataPermission

  }

  const handleAddRole = (val) => {

    const datePermission = mappingPermissionPayload()

    const data = {
      code: val.role_code,
      name: val.role,
      description: val.des,
      permissions: datePermission,
    }

    try {
      adminAddRole({
        params: data,
        token: token,
      }).then((res) => {
        if (res.status === 200) {
          ////// permission
          setHiddenError(true)
          //addPermission(res)
          getResultRole()
          setVisible(false)
        } else {
          if (res.data.errorCode === '2008') {
            wordError = word['err_role_code']
          } else {
            wordError = 'error'
          }
          setHiddenError(false)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }

  const handleUpdateRole = (val) => {

    const dataPermission = mappingPermissionPayload()

    const data = {
      code: val.role_code,
      name: val.role,
      description: val.des,
      permissions: dataPermission,
    }
    try {
      updateRolePermission({
        id: idRole,
        payload: data,
        token: token,
      }).then((response) => {
        if (response.status === 200) {
          ////// permission
          //addPermission(response)
          getResultRole()
          setVisible(false)
        }
      })
    } catch (error) {
      console.log(error)
    }
  }
  // const { getPermissionAdmin } = useContext(CounterContext)

  // const addPermission = (res) => {
  //   const permis = dataRolepermis.map((item) => {
  //     changeValueToAPi(item.permission)
  //     return item.permission
  //   })
  //   const admin = dataAdmin.map((item, index) => {
  //     changeValueToAPi(item.permission)
  //     return item.permission
  //   })
  //   const dataPermission = {
  //     role_id: res.data.id,
  //     permission: [...permis, ...admin],
  //   }
  //   try {
  //     mappingRole({
  //       params: dataPermission,
  //       token: token,
  //     }).then((res) => {
  //       if (res.status === 200) {
  //         getResultMenuList()
  //         getPermissionAdmin()
  //         setDataEdit(initalState.data)
  //       }
  //     })
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  const modalDelete = () => {
    return (
      <Delete
        visibleDelete={visibleDelete}
        setVisibleDelete={setVisibleDelete}
        state={'rolepermission'}
        data={record}
        renderData={getResultRole}
        setVisibleDrawer={setVisible}
      />
    )
  }

  const drawer = () => {
    return (
      <>
        <Modal
          maskClosable={false}
          title={<TextTitleBold>{titleDrawer}</TextTitleBold>}
          onCancel={() => {
            setDataEdit(initalState.data)
            setVisible(false)
            setFieldsNull()
            getResultMenuList()
            setHiddenError(true)
          }}
          visible={visible}
          width={'634px'}
          className="fix-modal"
          footer={renderButton_Drawer()}
          destroyOnClose
        >
          <Form
            form={form}
            onFinish={onFinish}
            className="layout-form-drawer-role"
            layout="vertical"
          >
            <fieldset disabled={disablePage}>
              <div hidden={hiddenError} style={{ marginBottom: 10 }}>
                <Alert message={wordError} type="error" showIcon />
              </div>
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    id="role_code"
                    name="role_code"
                    className="customValidation"
                    label={<h4>{word['Role_Code']}</h4>}
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter role code',
                      },
                    ]}
                  >
                    <Input placeholder="Please enter role code" size="large" />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item
                    id="role"
                    name="role"
                    className="customValidation"
                    label={<h4>{word['Role_Name']}</h4>}
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Please enter role name',
                      },
                    ]}
                  >
                    <Input placeholder="Please enter role name" size="large" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} style={{ paddingBottom: '15px' }}>
                <Col span={24}>
                  <Form.Item id="des" name="des" label={<h4>{word['Description']}</h4>}>
                    <Input placeholder="Please enter role description" size="large" />
                  </Form.Item>
                </Col>
              </Row>
              <TextTitleBold style={{ paddingBottom: '8px' }}>
                {word['Permission']}
              </TextTitleBold>
              <SelectTable
                setDataRolepermis={setDataRolepermis}
                dataEdit={dataEdit}
                setDataEdit={setDataEdit}
                permission={permission}
                disablePage={disablePage}
                word={word}
                style={{ paddingBottom: '15px' }}
              />
              <TextTitleBold style={{ marginTop: 24, paddingBottom: '8px' }}>
                {word['Admin_Management']}
              </TextTitleBold>
              <AdminManageTable
                setDataAdmin={setDataAdmin}
                dataEdit={dataEdit}
                menuAdmin={menuAdmin}
                setMenuAdmin={setMenuAdmin}
                permissionAdmin={permissionAdmin}
                getResultMenuList={getResultMenuList}
                word={word}
              />
            </fieldset>
          </Form>
          {modalDelete()}
        </Modal>
      </>
    )
  }

  return (
    <Container style={{ padding: 32 }} className="layout-git-master-unitmeasurment">
      {content()}
      {drawer()}
      {/* {modalDelete()} */}
    </Container>
  )
}
export default roleandpermission
